export function scrollToError(elementId: string) {
  setTimeout(() => {
    const errorField = document.getElementById(elementId) as HTMLInputElement;
    if (errorField) {
      errorField.parentElement?.scrollIntoView({ behavior: 'smooth' });
    }
  }, 100);
}
